import { render, staticRenderFns } from "./mycommentlike.vue?vue&type=template&id=ccc89992&scoped=true&"
import script from "./mycommentlike.vue?vue&type=script&lang=js&"
export * from "./mycommentlike.vue?vue&type=script&lang=js&"
import style0 from "./mycommentlike.vue?vue&type=style&index=0&id=ccc89992&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc89992",
  null
  
)

export default component.exports